import React from 'react'
import styled from 'styled-components'

const FileWrapper = ({ attributes, children, element, themeColor, fileCdnPath, fileDownloadPath }) => {
  const { title, url, size } = element
  const fileUrl = fileDownloadPath ? fileDownloadPath + url : url

  return (
    <div {...attributes}>
      <div contentEditable={false}>
        <FileContentWrapper>
          <FileIconWrapper themeColor={themeColor}>
            <i className="far fa-paperclip" />
          </FileIconWrapper>
          <FileTitleWrapper>
            <FileTitle themeColor={themeColor}>
              <FileLink href={`${fileUrl}?download=true`} download target="_blank" themeColor={themeColor}>
                {title}
              </FileLink>
            </FileTitle>
            <FileSize>{size}</FileSize>
          </FileTitleWrapper>
        </FileContentWrapper>
        {children}
      </div>
    </div>
  )
}

export default FileWrapper

const FileContentWrapper = styled.div`
  display: flex;
  border-radius: 3px;
  border: 1px solid ${props => props.theme.borderColor};
  width: 100%;
  background-color: ${props => props.theme.bgSecondLightest};

  margin-bottom: 15px;
  color: ${props => props.theme.textGreyTinted};
`
const FileTitleWrapper = styled.div`
  flex: 1 1 auto;
  min-width: 1px;
  text-align: left;
  padding-left: 0px;
  padding-right: 10px;
  flex-grow: 1;
  padding: 2.5px 10px;
`
const FileIconWrapper = styled.div`
  font-size: 16px;
  min-height: 100%;
  background: red;
  display: flex;
  min-width: 40px;
  align-items: center;
  justify-content: center;
  border-right: 1px solid ${props => props.theme.borderColor};
  background: ${props => props.theme.hoverBgLightestInverse};
  color: ${props => (props.themeColor ? props.themeColor : props.theme.primary)};
`
const FileTitle = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
`
const FileSize = styled.div`
  font-size: 12px;
`

const FileLink = styled.a`
  color: ${props => props.theme.textGreyTinted};
  :hover {
    color: ${props => (props.themeColor ? props.themeColor : props.theme.primary)};
    text-decoration: underline;
  }
`
